import React from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { useTranslation } from '../../../../../common/hooks/helper/useTranslation'
import { DoctorInfo } from '../../../../../common/components/DoctorInfo/DoctorInfo'
import { PatientDoctor } from '../../types/patientEvents.types'

type DeclineAppointmentDialogProps = {
  openState: [boolean, React.Dispatch<React.SetStateAction<boolean>>]
  doctor: PatientDoctor
}
const DeclineAppointmentDialog: React.FC<
  React.PropsWithChildren<DeclineAppointmentDialogProps>
> = ({ openState, doctor }) => {
  const { t } = useTranslation()
  const [isOpen, setOpenState] = openState

  return (
    <Dialog open={isOpen}>
      <DialogTitle>
        {t('appointment:patient.declineAppointmentDialogTitle')}
      </DialogTitle>
      <DialogContent>
        <Typography>
          {t('appointment:patient.declineAppointmentDialogText')}
        </Typography>
      </DialogContent>
      <DialogContent>
        <DoctorInfo
          doctor={doctor}
          linkToDoctor={`/patient/doctors/${doctor.id}`}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenState(false)} variant="outlined">
          {t('common:close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export { DeclineAppointmentDialog }
